import { PageHeader, Stack, TabNav, type TabNavItem } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { PageActionsProvider, PageActionsSlot } from '../../app/PageActions';
import { RouterLink } from '../../app/RouterLink';
import { useSession } from '../identity/session';
import { ExportButton } from '../reports/components/ExportButton';

/** Frame of the sales pages: title and tabs (sales, invoices, market days, prices). */
export function SalesLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { can } = useSession();
  const tabs: TabNavItem[] = (
    [
      { key: 'sales', label: t('sales.tabs.sales'), href: '/verkauf' },
      ...(can('invoices.read')
        ? ([
            {
              key: 'invoices',
              label: t('sales.tabs.invoices'),
              href: '/verkauf/rechnungen',
            },
          ] satisfies TabNavItem[])
        : []),
      { key: 'markets', label: t('sales.tabs.markets'), href: '/verkauf/maerkte' },
      {
        key: 'market',
        label: t('sales.tabs.marketDays'),
        href: '/verkauf/markttage',
      },
      { key: 'prices', label: t('sales.tabs.prices'), href: '/verkauf/preise' },
    ] satisfies TabNavItem[]
  ).map((tab) => ({
    ...tab,
    active: tab.href === '/verkauf' ? pathname === '/verkauf' : pathname.startsWith(tab.href),
  }));
  return (
    <PageActionsProvider>
      <Stack gap={4}>
        <PageHeader
          title={t('sales.title')}
          actions={
            <>
              <PageActionsSlot />
              {pathname === '/verkauf' && <ExportButton list="sales" />}
              {pathname.startsWith('/verkauf/rechnungen') && <ExportButton list="invoices" />}
            </>
          }
        />
        <TabNav label={t('sales.tabs.label')} items={tabs} linkComponent={RouterLink} />
        <Outlet />
      </Stack>
    </PageActionsProvider>
  );
}
